
/**
 * Module dependencies.
 */

import { UrlResolver } from 'slyk-web-libs/url-resolver';
import config from 'config';

/**
 * Resolver.
 */

const resolver = new UrlResolver({
  domain: config.get('app.domain'),
  protocol: window.location.protocol
});

/**
 * Dashboard resolver.
 */

const dashboardResolver = new UrlResolver({
  domain: config.get('dashboardApp.domain'),
  protocol: window.location.protocol
});

/**
 * Export `payspaceUrlResolver`.
 */

export function payspaceUrlResolver(domainSlug: string, route: string) {
  try {
    return resolver.resolve(domainSlug, route);
  } catch (error) {
    throw new Error('You must provide a valid route');
  }
}

/**
 * Export `dashboardUrlResolver`.
 */

export function dashboardUrlResolver(payspaceSlug: string, route: string) {
  try {
    return dashboardResolver.resolve(payspaceSlug, route);
  } catch (error) {
    throw new Error('You must provide a valid route');
  }
}

/**
 * Export `getAppDownloadUrl`.
 */

export function getAppDownloadUrl(
  payspaceSlug: string,
  code: string | null | undefined
): string {
  if (code) {
    return resolver.resolve(payspaceSlug, `/r/${code}`);
  }

  return resolver.resolve(payspaceSlug, '/get');
}
